import { render } from "./Links.vue?vue&type=template&id=64709e0c"
import script from "./Links.vue?vue&type=script&lang=ts"
export * from "./Links.vue?vue&type=script&lang=ts"
script.render = render

export default script